import React, { Component } from 'react';
import SignatureCanvas from 'react-signature-canvas'

export default class SignaturePod extends Component {
  constructor(props) {
    super(props);
    this.validate = this.validate.bind(this)
    this.sigPad = {}
    this.state = {
      url: "",
      validated: false
    };
  }
  clear = (e) => {
    e.preventDefault()
    this.props.sign("")

    this.setState({url: "",validated: false})
    this.sigPad.clear()
  }
  setSigPad(ref){
    this.sigPad = ref
  }
  validate(e){
    e.preventDefault()
    let url = this.sigPad.getTrimmedCanvas().toDataURL('image/png')
    this.props.sign(url)
    this.setState({
      validated: true,
      url: url
    })
  }
  render() {
    return (
      <div>
        {this.state.validated ? (
          <div>
            <img height="100px" src={this.state.url} alt=""/>
            <a href="" onClick={this.clear} className="btn"><i className="material-icons">delete</i></a>
          </div>
        ) : (
          <div>
            <SignatureCanvas penColor='black'
            canvasProps={{height: 500,className: "sign-pad"}}
            ref={(ref) => { this.setSigPad(ref) }}/>
            <a href="" onClick={this.clear} className="btn"><i className="material-icons">delete</i></a>
            <a href="" onClick={this.validate} className="right btn"><i className="material-icons">done</i></a>
          </div>
          )}
      </div>
    );
  }
}
